<template>
  <div id="home">

    <div>
      <div class="title">
        <span></span>
        <div style="display: flex;">
          <span class="btn btn_pc" @click="save" style="margin-right: 10px;" >Save</span>
        </div>
      </div>
      <div class="mainContent">
        <div>
          <div class="title">
            Prompt Configuration - Business
          </div>
          <div class="mainItem">
            <h1>
              Business Type<span>(required)</span>
            </h1>
            <p>The type for your business.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="post workout recovery lab, sport therapy." v-model="object.business_type"></el-input>

            <h1>
              Keywords<span>(required)</span>
            </h1>
            <p>Keywords that can be selected for generating reviews.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}"
            class="div" placeholder="Invigorating,Relaxing, Restorative, Soothing, Clean, Comfortable, Supportive, Friendly, Welcoming" v-model="keywords"
            @blur="get_workword_number"></el-input>

            <h1>
              Business Description
            </h1>
            <p>A description of the business context to help AI understand the business better.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="Service to the inland Empire starting here in our very own town, Corona.Recovery Lab is constantly looking to find new ways to improve services. Our innovative team are always looking at expanding our facility to incorporate new and proven therapies in healing technology, making sure you heal faster and perform better." v-model="object.company_description"></el-input>

            <h1>
              Common Rules
            </h1>
            <p>The rules that AI should follow when generating all reviews</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="Write with incomplete sentences. Include “Sport therapy”,”Corona”,”Inland Empire”, or “best sport therapy” in the reviews when possible. Only use “Recovery Lab” sporadically. Don’t use “--” in all reviews. Don’t  use “,” or semicolon in all reviews." v-model="object.common_rules"></el-input>

            <h1>
              Rules fore the 1st variation
            </h1>
            <p>The rules specific to generate the first review.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div"
             placeholder="Make it similar to yelp reviews, keep it concise, and easy to read. Write with incomplete senteces. Make grammar errors. Write in the 3rd grade level. Use personal stories when possible" v-model="object.review_variation1"></el-input>

            <h1>
              Rules fore the 2st variation
            </h1>
            <p>The rules specific to generate the second review.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="Make it similar to yelp reviews, keep it concise, and easy to read. Write with incomplete senteces. Make grammar errors. Write in the 3rd grade level. Use personal stories when possible" v-model="object.review_variation2"></el-input>

            <h1>
              Rules fore the 3st variation
            </h1>
            <p>The rules specific to generate the third review.</p>
            <el-input type="textarea" resize="none" :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="Make it similar to yelp reviews, keep it concise, and easy to read. Write with incomplete senteces. Make grammar errors. Write in the 3rd grade level. Use personal stories when possible" v-model="object.review_variation3"></el-input>
          </div>
        </div>
        <div>
          <div class="title">
            Preivew
          </div>
          <div class="mainItem">
            <h1 style="justify-content: space-between;">
              Select Keywords
              <a style="font-size:14px;color:#5856D6;cursor: pointer;" @click="is_edit = true" v-if="!is_edit">edit</a>
              <a style="font-size:14px;color:#5856D6;cursor: pointer;" @click="is_edit = false" v-if="is_edit">confirm</a>
            </h1>
            <div class="labels">
              <span v-if="!is_edit" v-for="item,index in preview_keyword_array" :key="index">{{item}}</span>
              <el-input v-if="is_edit" type="textarea" resize="none"
              :autosize="{ minRows: 4, maxRows: 15}" class="div" placeholder="Please enter"
              v-model="preview_keywords"
              @blur="check_workword"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        <span></span>
        <div style="display: flex;">
          <span class="btn btn_mobile" @click="save" style="margin-right: 10px;" >Save</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,putActionApi } from '@/network/manageApi';
  import moment from 'moment/moment';
  export default {
    name: 'SetAiBusinessPromoterInfo',
    components: {

    },
    data() {
      return {
        object: {},
        keywords: "",
        keyword_array: [],
        preview_keywords: "",
        preview_keyword_array: [],
        is_edit: false,
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
      this.form_loading = true
      this.object = {business_type:"",common_rules: "",company_description: "",review_variation1: "",review_variation2: "", review_variation3: ""}
      getActionApi('/review/business-promoter/company').then(res => {
        this.object.business_type = res.data.business_type
        this.keywords = res.data.keywords.join(",")
        this.keyword_array = res.data.keywords
        this.object.company_description = res.data.company_description
        this.object.common_rules = res.data.common_rules
        this.object.review_variation1 = res.data.review_variation1
        this.object.review_variation2 = res.data.review_variation2
        this.object.review_variation3 = res.data.review_variation3
        this.preview_keywords = res.data.customer_keywords.join(",")
        this.preview_keyword_array = res.data.customer_keywords
      })
    },
    methods:{
      check_workword() {
        let use_keyword = this.preview_keywords.replaceAll(/^,?\s*|\s*,?$/g, '');
        if(use_keyword) {
          let array = use_keyword.split(",")
          let target_array = []
          for(let item of array) {
            let target = item.replaceAll(/^,?\s*|\s*,?$/g, '')
            if(target != "") {
              target_array.push(target)
            }
          }
          this.preview_keyword_array = target_array
          this.preview_keywords = target_array.join(",")
        } else {
          this.preview_keyword_array = []
        }
      },
      get_workword_number() {
        let use_keyword = this.keywords.replaceAll(/^,?\s*|\s*,?$/g, '');
        if(use_keyword) {
          let array = use_keyword.split(",")
          let target_array = []
          for(let item of array) {
            let target = item.replaceAll(/^,?\s*|\s*,?$/g, '')
            if(target != "") {
              target_array.push(target)
            }
          }
          this.keyword_array = target_array
          this.keywords = target_array.join(",")
        } else {
          this.keyword_array = []
        }
      },
      moment,
      save() {
        if(!this.object.business_type) {
          this.$message({
            message: 'Please enter business type.',
            type: 'warning'
          });
          return;
        }
        if(this.keyword_array.length == 0) {
          this.$message({
            message: 'Please enter keywords.',
            type: 'warning'
          });
          return;
        }
        if(this.preview_keyword_array.length == 0) {
          this.$message({
            message: 'Please enter customer keywords.',
            type: 'warning'
          });
          return;
        }
        let param = {business_type: this.object.business_type,
        description: this.object.company_description,
        common_rule: this.object.common_rules,review_variation1: this.object.review_variation1,
        review_variation2: this.object.review_variation2,review_variation3: this.object.review_variation3}
        param.keywords = this.keyword_array
        param.customer_keywords = this.preview_keyword_array
        this.form_loading = true
        putActionApi("/review/business-promoter/company", param).then((res) => {
          if(res.code == 201 || res.code == 200) {
            this.$message.success({message: "Save Success"});
          }
        }).catch((err) => {
          this.$message.error({message: err.response.data.details.data.message});
        }).finally((res) => {
          this.form_loading = false
        })
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .div{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;}
  .label{display: flex;align-items: center;justify-content: center;}
  .label .no{background-color: #FED7D7;color: #822727;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .label .yes{background-color: #b3edff;color: #0075cb;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .pager{display: flex;justify-content: center;}
  .btn{height:40px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .divt{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .margin-top-switch {margin-top: 10px;width: 500px;}
  .btn_pc {display: flex;}
  .btn_mobile {display: none;}
  .comments {width: 50%;}
  .mainContent{display: grid;grid-template-columns: 1fr 1fr;grid-gap: 20px;}
  .mainItem{padding:30px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 6px;background-color: #ffffff;}
  .mainItem h1{color:#2D3748;display: flex;align-items: center;}
  .mainItem h1 span{color:#B54042;margin-left: 10px;font-weight: normal;}
  .mainItem p{color:#A0ABC0;font-size: 14px;}
  .mainItem .div{padding:0px;font-size: 14px;border-radius: 10px;margin: 20px 0;color: #2D3648;width: 100%;border:none;}
  .mainItem .labels{display: flex;flex-wrap: wrap;}
  .mainItem .labels span{background-color: #EEEEFF;color:#5856D6;height:26px;border-radius: 13px;padding:0 20px;line-height: 26px;margin:0 10px 10px 0;font-size: 14px;}
  @media (max-width: 768px) {
    .mainContent{grid-template-columns: 1fr;}
    .title{flex-direction: column;}
    .div{padding:20px 10px;}
    .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
    .margin-top-switch {margin-top: 10px;width: 90%;}
    .comments {width: 98%;}
    .name {width: 98%;}
    .btn_pc {display: none;}
    .btn_mobile {display: flex;margin-top:20px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .title{flex-direction: column;}
    .div{padding:20px 10px;}
    .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
    .margin-top-switch {margin-top: 10px;width: 90%;}
    .comments {width: 98%;}
    .name {width: 98%;}
    .btn_pc {display: none;}
    .btn_mobile {display: flex;}
  }
  .font-size-16 {font-size: 20px;}
</style>
